module.exports = __webpack_public_path__ + "static/media/main.2545ce71.jpg";